import React from "react";

export function EditIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.78 55" {...props}>
      <g id="edit_dark" data-name="edit dark">
        <g>
          <polygon
            className="cls-1"
            points="36.79 11.37 15.84 32.32 14.81 38.5 20.98 37.47 41.94 16.51 36.79 11.37"
          />
          <path
            className="cls-1"
            d="m52.24,1.06h0c-1.42-1.42-3.73-1.42-5.15,0l-8.46,8.46,5.15,5.15,8.46-8.46c1.42-1.41,1.42-3.73,0-5.15Z"
          />
        </g>
        <path
          className="cls-1"
          d="m45.08,55H9.7c-5.35,0-9.7-4.35-9.7-9.7V9.92C0,4.57,4.35.22,9.7.22h23.54v5.92H9.7c-2.08,0-3.78,1.69-3.78,3.78v35.39c0,2.08,1.69,3.78,3.78,3.78h35.38c2.08,0,3.78-1.69,3.78-3.78v-26.86h5.92v26.86c0,5.35-4.35,9.7-9.7,9.7Z"
        />
      </g>
    </svg>
  );
}
